import { render } from "./ResetPasswordModal.vue?vue&type=template&id=6da5b682&scoped=true"
import script from "./ResetPasswordModal.vue?vue&type=script&lang=js"
export * from "./ResetPasswordModal.vue?vue&type=script&lang=js"

import "./ResetPasswordModal.vue?vue&type=style&index=0&id=6da5b682&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da5b682"]])

export default __exports__